import LoginPage from "app/pages/login";
import LogoutPage from "app/pages/logout";
import UserProfilePage from "app/pages/user";
import ColorVariant from "app/pages/colorVariant";
import SizeVariantPage from "app/pages/sizeVariant";
import ProductPage from "app/pages/product";
import ProductDetail from "app/pages/product/detail";
import CategoryPage from "app/pages/category";
import CustomerPage from "app/pages/customer";
import SupplierPage from "app/pages/supplier";
import SalesOrderPage from "app/pages/salesOrder";
import CreateSalesOrderPage from "app/pages/salesOrder/create";
import UpdateSalesOrderPage from "app/pages/salesOrder/update";
import CustomerOrderQueuePage from "app/pages/salesOrder/customerOrderQueue";
import CustomerOrderList from "app/pages/salesOrder/customerOrderList";
import CustomerOrderListGrid from "app/pages/salesOrder/customerOrderListGrid";
import SalesOrderEditRequestPage from "app/pages/salesOrderEditRequest";
import CreateSalesOrderEditRequestPage from "app/pages/salesOrderEditRequest/create";
import UpdateSalesOrderEditRequestPage from "app/pages/salesOrderEditRequest/update";
import InvoicePage from "app/pages/invoice";
import CreateInvoicePage from "app/pages/invoice/create";
import InvoiceDetailPage from "app/pages/invoice/detail";
import PurchaseOrderPage from "app/pages/purchaseOrder";
import CreatePurchaseOrderPage from "app/pages/purchaseOrder/create";
import UpdatePurchaseOrder from "app/pages/purchaseOrder/update";
import ReceiveOrderPage from "app/pages/receiveOrder";
import UpdateReceiveOrder from "app/pages/receiveOrder/update";
import DeliveryOrderPage from "app/pages/deliveryOrder";
import PackingOrderPage from "app/pages/deliveryOrder/packing";
import DeliveryPage from "app/pages/deliveryOrder/delivery";
import OrderBelumDibeliPage from "app/pages/deliveryOrder/orderBelumDibeli";
import DailyOmzet from "app/pages/report/dailyOmzet";
import TopCustomer from "app/pages/report/topCustomer";
import TopSales from "app/pages/report/topSales";
import TopProduct from "app/pages/report/topProduct";
import StockWarehouse from "app/pages/report/stockWarehouse";
import TopSupplier from "app/pages/report/topSupplier";
import PaymentReportPage from "app/pages/report/paymentReport";
import CreditRecapReportPage from "app/pages/report/creditRecap";
import CreditHistoryPage from "app/pages/report/creditHistory";
import ProductCodePage from "app/pages/productCode";
import StockOpname from "app/pages/stockOpname";
import CreateStockOpname from "app/pages/stockOpname/create";
import Scrap from "app/pages/scrap";
import CreateScrap from "app/pages/scrap/create";
import ReturSupplier from "app/pages/returSupplier";
import CreateReturSupplier from "app/pages/returSupplier/create";
import ReturCustomer from "app/pages/returCustomer";
import CreateReturCustomer from "app/pages/returCustomer/create";
import StockMovement from "app/pages/stockMovement";
import CreatePurchaseOrderManualPage from "app/pages/purchaseOrder/createManual";
import StockOpnameDetail from "app/pages/stockOpname/detail";
import WarehouseTransferList from "app/pages/warehouseTransfer";
import WarehouseTransferCreate from "app/pages/warehouseTransfer/create";
import WarehouseTransferDetail from "app/pages/warehouseTransfer/detail";
import StoreReportTransactionsPage from "app/pages/storeReport/transactions";
import StoreReportSalesTotalsPage from "app/pages/storeReport/salesTotals";
import StoreReportMembershipPage from "app/pages/storeReport/membership";
import StoreReportStockPage from "app/pages/storeReport/stock";
import StoreReportStockMutationPage from "app/pages/storeReport/stockMutation";
import StoreReportWarehouseInOutPage from "app/pages/storeReport/warehouseInOut";
import StoreReportSalesByProductPage from "app/pages/storeReport/salesByProduct";
import StoreReportSalesByCategoryPage from "app/pages/storeReport/salesByCategory";
import StoreReportSalesByCashierPage from "app/pages/storeReport/salesByCashier";
import StoreReportSalesByPaymentMethodPage from "app/pages/storeReport/salesByPaymentMethod";
import StoreReportDailyClosingPage from "app/pages/storeReport/dailyClosing";

const routes = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/report/daily-omzet",
    element: <DailyOmzet />,
  },
  {
    path: "/report/top-customer",
    element: <TopCustomer />,
  },
  {
    path: "/report/top-sales",
    element: <TopSales />,
  },
  {
    path: "/report/top-product",
    element: <TopProduct />,
  },
  {
    path: "/report/stock-warehouse",
    element: <StockWarehouse />,
  },
  {
    path: "/report/top-supplier",
    element: <TopSupplier />,
  },
  {
    path: "/report/payment",
    element: <PaymentReportPage />,
  },
  {
    path: "/report/credit-recap",
    element: <CreditRecapReportPage />,
  },
  {
    path: "/report/credit-history",
    element: <CreditHistoryPage />,
  },
  {
    path: "/report/warehouse-in-out",
    element: <StoreReportWarehouseInOutPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/logout",
    element: <LogoutPage />,
  },
  {
    path: "/sales_order",
    element: <SalesOrderPage />,
  },
  {
    path: "/sales_order/edit_request",
    element: <SalesOrderEditRequestPage />,
  },
  {
    path: "/sales_order/create",
    element: <CreateSalesOrderPage />,
  },
  {
    path: "/sales_order/update/:id",
    element: <UpdateSalesOrderPage />,
  },
  {
    path: "/sales_order/antrian_produk/:product_code/:color_name/:size_name/:product_id/:color_variant_id/:size_variant_id/:min_total",
    element: <CustomerOrderQueuePage />,
  },
  {
    path: "/sales_order/antrian_produk",
    element: <CustomerOrderList />,
  },
  {
    path: "/sales_order/antrian_produk_grid",
    element: <CustomerOrderListGrid />,
  },
  {
    path: "/sales_order_edit_request",
    element: <SalesOrderEditRequestPage />,
  },
  {
    path: "/sales_order_edit_request/create/:salesOrderId",
    element: <CreateSalesOrderEditRequestPage />,
  },
  {
    path: "/sales_order_edit_request/update/:id/:tabCode",
    element: <UpdateSalesOrderEditRequestPage />,
  },
  {
    path: "/purchase_order",
    element: <PurchaseOrderPage />,
  },
  {
    path: "/purchase_order/create",
    element: <CreatePurchaseOrderPage />,
  },
  {
    path: "/purchase_order/create_manual",
    element: <CreatePurchaseOrderManualPage />,
  },
  {
    path: "/purchase_order/update/:id",
    element: <UpdatePurchaseOrder />,
  },
  {
    path: "/receive_order",
    element: <ReceiveOrderPage />,
  },
  {
    path: "/receive_order/update/:id",
    element: <UpdateReceiveOrder />,
  },
  {
    path: "/packing_order",
    element: <PackingOrderPage />,
  },
  {
    path: "/delivery",
    element: <DeliveryPage />,
  },
  {
    path: "/delivery/order_belum_dibeli",
    element: <OrderBelumDibeliPage />,
  },
  {
    path: "/delivery_order",
    element: <DeliveryOrderPage />,
  },
  {
    path: "/invoice",
    element: <InvoicePage />,
  },
  {
    path: "/invoice/create",
    element: <CreateInvoicePage />,
  },
  {
    path: "/invoice/detail/:id",
    element: <InvoiceDetailPage />,
  },
  {
    path: "/profile",
    element: <UserProfilePage />,
  },
  {
    path: "/color-variant",
    element: <ColorVariant />,
  },
  {
    path: "/size-variant",
    element: <SizeVariantPage />,
  },
  {
    path: "/color-variant",
    element: <ColorVariant />,
  },
  {
    path: "/category",
    element: <CategoryPage />,
  },
  {
    path: "/product",
    element: <ProductPage />,
  },
  {
    path: "/product/detail/:id",
    element: <ProductDetail />,
  },
  {
    path: "/product-code/:id",
    element: <ProductCodePage />,
  },
  {
    path: "/customer/*",
    element: <CustomerPage />,
  },
  {
    path: "/supplier/*",
    element: <SupplierPage />,
  },
  {
    path: "/stock-opname",
    element: <StockOpname />,
  },
  {
    path: "/stock-opname/:id",
    element: <StockOpnameDetail />,
  },
  {
    path: "/stock-opname/create",
    element: <CreateStockOpname />,
  },
  {
    path: "/scrap",
    element: <Scrap />,
  },
  {
    path: "/scrap/create",
    element: <CreateScrap />,
  },
  {
    path: "/retur-supplier",
    element: <ReturSupplier />,
  },
  {
    path: "/retur-supplier/create",
    element: <CreateReturSupplier />,
  },
  {
    path: "/retur-customer",
    element: <ReturCustomer />,
  },
  {
    path: "/retur-customer/create",
    element: <CreateReturCustomer />,
  },
  {
    path: "/stock-movement/:id",
    element: <StockMovement />,
  },
  {
    path: "/warehouse-transfer",
    element: <WarehouseTransferList />,
  },
  {
    path: "/warehouse-transfer/create",
    element: <WarehouseTransferCreate />,
  },
  {
    path: "/warehouse-transfer/:id",
    element: <WarehouseTransferDetail />,
  },
  {
    path: "/store-report/transactions",
    element: <StoreReportTransactionsPage />,
  },
  {
    path: "/store-report/sales-totals",
    element: <StoreReportSalesTotalsPage />,
  },
  {
    path: "/store-report/membership",
    element: <StoreReportMembershipPage />,
  },
  {
    path: "/store-report/outlet-stock",
    element: <StoreReportStockPage />,
  },
  {
    path: "/store-report/stock-mutation",
    element: <StoreReportStockMutationPage />,
  },
  {
    path: "/store-report/sales-by-product",
    element: <StoreReportSalesByProductPage />,
  },
  {
    path: "/store-report/sales-by-category",
    element: <StoreReportSalesByCategoryPage />,
  },
  {
    path: "/store-report/sales-by-cashier",
    element: <StoreReportSalesByCashierPage />,
  },
  {
    path: "/store-report/sales-by-payment-method",
    element: <StoreReportSalesByPaymentMethodPage />,
  },
  {
    path: "/store-report/daily-closing",
    element: <StoreReportDailyClosingPage />,
  },
];

export default routes;
